import Animation from '../../animations/animation'
import * as d3 from 'd3-selection'

/*
 * Animation which takes a line and splits it into new lines.
 */
class SplitLineAnimation extends Animation {

  constructor (options) {
    super(options)
    this.ripple = true
  }

  match (serie) {
    if (!this.previous.scalers.x || !this.seriesChanged) {
      // We don't have previous data or series didn't change
      return false
    }

    let ticks0 = this.previous.scalers.x.groupScale.domain()
      , ticks1 = this.scalers.x.groupScale.domain()

    return ticks0.length === ticks1.length && // Same tick count on bottom
           this.exitingSeries.size() === 1 && // One serie being removed
           this.series.size() > this.previous.series.size() // We gained series
  }

  /*
   * Returns the new series
   */
  _newSeries () {
    return this.series.selection().data().filter(serie => {
      return this.previous.series.data().indexOf(serie) === -1
    })
  }

  animate (serie, entering, selection, merged, exiting) {
    if (exiting.size()) {
      // We want the exiting serie to be on top of the new series

      // Determine the index of the last new serie
      let newSeries = this._newSeries()
        , idx = this.series.selection().data().indexOf(newSeries[newSeries.length - 1])
        , referenceNode = this.series.nodes()[idx + 1]

      // This way the exiting node is on top of the new nodes, but not on top of other nodes
      // That's why can't simply do a `exiting.selection().raise()` b/c it'd be too high in the dom
      exiting.selection().each(function () {
        this.parentNode.insertBefore(this, referenceNode)
      })

      let totalLength = exiting.selectAll('path').node().getTotalLength()

      // Set a stroke dasharray to hide this path, which will adjust as we transition
      exiting.selectAll('path')
             .attr('stroke-dasharray', `${totalLength} ${totalLength}`)
    } else if (entering.size()) {
      // New serie, split from the exiting serie
      let exitingSerie = this.exitingSeries.selection()
        , previousPoints = exitingSerie.datum().points
        , pointWidth = exitingSerie.node().querySelector('.point').getBBox().width
        , scaler = {
          x: this.previous.scalers.x.center,
          y: (raw, d) => {
            let point = previousPoints.find(p => p.rangeId === d.rangeId)
            return this.previous.yScale(point.raw)
          }
        }

      // Add the new path elements
      this._insertPaths(entering)

      // Then add the points at the location of the exiting series points
      // The start and end scalers are the same, so the points code doesn't
      // try moving them. We'll handle that transition so we can work the `path`
      // at the same time.
      this._points(merged, scaler, scaler)

      merged.selectAll('.point')
            .duration(this.timing.duration)
            .delay(this.timing.delay)
            .tween('splitter', this._splitTweener(exitingSerie.datum(), d => d))
            .on('start', (d, i, all) => {
              if (i < all.length - 1) {
                let x = this.previous.scalers.x.center(d3.select(all[i + 1]).datum().rangeId)
                  , offset = i === all.length - 2 ? 0 : pointWidth / 2
                  , path = exitingSerie.selectAll('path')
                  , length = this._subLength(exitingSerie, x) + offset // Chop off the point width so this path doesn't cover new points
                  , previousPoints = exitingSerie.selectAll('.point:not(.head)')
                                                 .filter(d => {
                                                   return Math.round(this.previous.scalers.x.center(d.rangeId)) <= x
                                                 })

                this._shrinkPath(path, length, path.node().getTotalLength(), previousPoints)
              }
            })
    } else {
      // Basic update
      this._updateDrawing(merged)
    }

  }

}

export default SplitLineAnimation
